<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta v-if="msgAlerta" class="row-space" :mensagem="msgAlerta" />

    <div class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <div class="form-item" style="flex: 0 0 90px;">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdpessoa) }}</div>
                </div>

                <div class="form-item-char20">
                    <label v-if="!ckCpfCnpjOk" class="label-link" @click="showModalCpfCnpj=true">CPF/CNPJ</label>
                    <label v-if="ckCpfCnpjOk" class="label-caption">CPF/CNPJ</label>
                    <div :class="{
                        'field-label-alert': !ckCpfCnpjOk,
                        'field-label': ckCpfCnpjOk,
                        'field-label-center': true}">{{ objEdicao.cpfcnpj }}</div>
                </div>

                <div class="form-item flexible">
                    <label class="label-caption" for="nmpessoa">Nome/Razão Social</label>
                    <input type="text" v-model="objEdicao.nmpessoa" id="nmpessoa" required maxlength="100" v-uppercase />
                </div>
                <div class="form-item flexible">
                    <label class="label-caption" for="apelido">Apelido/Nome Fantasia</label>
                    <input type="text" v-model="objEdicao.apelido" id="apelido" maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Endereço</label>
                    <input type="text" v-model="objEdicao.endereco" maxlength="100" v-uppercase />
                </div>
                <div class="form-item-char10">
                    <label class="label-caption">Número</label>
                    <input type="text" class="input-right" v-model="edNmEndereco" v-number maxlength="5" />
                </div>
                <div class="form-item">
                    <label class="label-caption">Complemento</label>
                    <input type="text" v-model="objEdicao.complemento" maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Bairro</label>
                    <input type="text" v-model="objEdicao.nmbairro" maxlength="100" v-uppercase />
                </div>

                <LocalidadeSelect class="form-item flexible" v-model:idSelecionado="objEdicao.idlocalidade" />

                <div class="form-item-char10">
                    <label class="label-caption">CEP</label>
                    <input type="text" v-model="objEdicao.cep" v-cep maxlength="10" />
                </div>
            </div>
            
            
            <div class="row row-space">
                <div class="form-item-char15">
                    <label class="label-caption">Inscrição Estadual</label>
                    <input type="text" class="input-center" v-model="edIe" v-number maxlength="12" />
                </div>
                
                <div class="form-item-telefone">
                    <label class="label-caption" for="fone">Telefone</label>
                    <input type="text" v-model="objEdicao.fone" id="fone" v-phone maxlength="15" />
                </div>

                <div class="form-item flexible">
                    <label class="label-caption" for="email">Email</label>
                    <input type="email" v-model="objEdicao.email" id="email" />
                </div>
            </div>

            <div class="row-end">
                <label for="ckAtivo">Ativo</label>
                <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
            </div>

            <div class="row-end">
                <label for="ckProdutorAtivo">Cadastro de Produtor Ativo</label>
                <input type="checkbox" class="input-checkbox" id="ckProdutorAtivo" v-model="ckProdutorAtivo" />
            </div>

            <div class="row-end">
                <label for="ckExportaOperador">Exportar para aplicativo dos operadores</label>
                <input type="checkbox" class="input-checkbox" id="ckExportaOperador" v-model="ckExportaOperador" />
            </div>


            <div class="row-end margin-top10">
                <button v-if="objEdicao.id>0" type="button" @click="showModalSenha=true">Alterar Login</button>
                <button class="btn-confirm" type="submit">Salvar</button>
                <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            </div>
        </form>
    </div>

    <div>
        <ModalRedefinirSenha
            :visible="showModalSenha"
            @update:visible="(value) => (showModalSenha = value)"
            @submit="redefinirLoginSenha" />
    </div>

    <CpfCnpjModal
        v-if="showModalCpfCnpj"
        @close="showModalCpfCnpj = false"
        @cpfCnpjSubmitted="arrumarCpfCnpj"
    />

    <DialogOkModal 
      v-if="showOkModal" 
      :message="msgOkModal" 
      @close="showOkModal=false" 
      @confirmed="showOkModal=false" />
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { criarPessoa } from '@/models/Pessoa';
import { Funcoes } from '@/funcoes/utils';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import CpfCnpjModal from '@/components/modals/CpfCnpjModal.vue';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import LocalidadeSelect from '@/selects/LocalidadeSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import ModalRedefinirSenha from '@/components/modals/ModalRedefinirSenha.vue';

const emit=defineEmits(['close', 'salvo']);
const props=defineProps({
    idEdicao: {type: Number, default: 0},
    cpfCnpjNovo: {type: String, default: ''}});

const ckAtivo = ref(false);
const ckCpfCnpjOk= ref(true);
const ckExportaOperador = ref(false);
const ckProdutorAtivo = ref(false);
const edIe = ref(null);
const edNmEndereco = ref(null);
const objEdicao = criarPessoa();
const isLoading = ref(false);
const msgAlerta = ref(null);
const msgOkModal = ref(null);
const showModalCpfCnpj = ref(false);
const showModalSenha = ref(false);
const showOkModal = ref(false);

async function arrumarCpfCnpj(value){
    showModalCpfCnpj.value=false;
    try{
        msgAlerta.value  = null;
        isLoading.value     = true;
        const r = await genericPut('/cad/pessoa', {
            id: objEdicao.id,
            cpfcnpj: value, 
            idusuario: globalStore.idusuario});
        if (r.bolok == 1){objEdicao.cpfcnpj = value; ckCpfCnpjOk.value=true;}else{msgAlerta.value = r.error}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally {isLoading.value = false;}
}

const submitForm = async () => {
    try {
        isLoading.value=true;
        objEdicao.ativo = ckAtivo.value ? 'S' : 'N';
        objEdicao.ckexportaoperador = ckExportaOperador.value ? 'S' : 'N';
        objEdicao.ckprodutor_ativo = ckProdutorAtivo.value ? 'S' : 'N';
        objEdicao.inscricaoestadual = Funcoes.integerFromString(edIe.value);
        objEdicao.nmendereco = Funcoes.integerFromString(edNmEndereco.value);
        const response = await genericPut('/cad/pessoa', objEdicao);
        if (response.bolok===1){
            emit('salvo');
            emit('close');
        }else{
            msgAlerta.value = `ATENÇÃO: ${response.erro}`
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
};

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value=true;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('pessoa', props.idEdicao);
                Object.assign(objEdicao, req[0]);
            }catch (error){console.error('Erro leitura dos dados', error);}
        }else{
            objEdicao.idmunicipio = globalStore.idmunicipio;
            objEdicao.cpfcnpj = props.cpfCnpjNovo;
        }
        objEdicao.idusuario     = globalStore.idusuario;
        ckAtivo.value           = objEdicao.ativo==='S';
        ckExportaOperador.value = objEdicao.ckexportaoperador==='S';
        ckProdutorAtivo.value   = objEdicao.ckprodutor_ativo==='S';
        edIe.value              = Funcoes.formatInteger(objEdicao.inscricaoestadual);
        edNmEndereco.value      = Funcoes.formatInteger(objEdicao.nmendereco);
        try{
            Funcoes.validarCNPJouCPF(objEdicao.cpfcnpj);
            ckCpfCnpjOk.value=true;
        }catch (error){ckCpfCnpjOk.value=false}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
};

const redefinirLoginSenha = async({username, senha}) => {
    try{
        isLoading.value = true;
        const r = await genericPut('/cad/pessoa', {id: objEdicao.id, idmunicipio: objEdicao.idmunicipio, login: username, senha: senha});
        if (r.bolok == 1){
            msgOkModal.value="Nova senha alterada com sucesso";
            showOkModal.value=true;
        }else{msgAlerta.value = `ATENÇÃO: ${r.erro}`}
    } catch (error){console.log(error); msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally {isLoading.value = false;}
}

onMounted(lerDados);
</script>